<app-screen-content [isLoading]="model.isLoading">
  <ng-container title>
    <img src="assets/icons/ic-financial@3x.svg" alt="" />
    <span>Financial situation</span>
  </ng-container>

  <ng-container instruction>
    Please complete this form with as much detail as you are able to. It is
    designed to give us as much relevant information as possible about your
    organisation’s overall financial situation. We will then be able to make
    appropriate recommendations to your organisation. Omission of, or the
    provision of inaccurate or incomplete data will reduce and affect the
    quality of investment advice and/or recommendation(s) we provide to you.
  </ng-container>

  <div body>
    <ng-template #confirmationModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Attention</h4>
      </div>
      <div class="modal-body">
        You are only required to provide one of these information, if you choose
        another option, your previous inputs will not be saved.
        <p>Would you like to continue?</p>
      </div>
      <div class="modal-footer">
        <app-primary-button
          buttonType="button"
          [outline]="true"
          (click)="modal.dismiss()"
        >
          No
        </app-primary-button>
        <app-primary-button buttonType="button" (click)="modal.close('save')">
          Yes
        </app-primary-button>
      </div>
    </ng-template>

    <form [formGroup]="form" (ngSubmit)="model.onSubmit()">
      <section class="box financial-situation-group">
        <app-label-field>
          <ng-container title>Current financial situation</ng-container>
          <ng-container helperText>
            Please upload one of these documents</ng-container
          >
        </app-label-field>
        <div class="row radio-row">
          <div class="col-xl-4">
            <app-radio
              name="selectedFinancialSituationOption"
              formControlName="selectedFinancialSituationOption"
              radioValue="financial-statement"
              label="Latest financial statement"
              [value]="selectedFinancialSituationOptionControl.value"
              [selectedContentTemplate]="
                globals.isLessThan1200Width
                  ? templateRefFinancialStatement
                  : null
              "
              (click)="
                selectedFinancialSituationOptionClick(
                  $event,
                  'financial-statement',
                  'financial-situation-group'
                )
              "
            ></app-radio>
          </div>
          <div class="col-xl-4">
            <app-radio
              name="selectedFinancialSituationOption"
              formControlName="selectedFinancialSituationOption"
              radioValue="other-documents"
              label="Other documents"
              [value]="selectedFinancialSituationOptionControl.value"
              [selectedContentTemplate]="
                globals.isLessThan1200Width ? templateRefOtherDocuments : null
              "
              (click)="
                selectedFinancialSituationOptionClick(
                  $event,
                  'other-documents',
                  'financial-situation-group'
                )
              "
            ></app-radio>
          </div>
          <div class="col-xl-4">
            <app-radio
              name="selectedFinancialSituationOption"
              formControlName="selectedFinancialSituationOption"
              radioValue="non-disclosure"
              label="Non-disclosure"
              [value]="selectedFinancialSituationOptionControl.value"
              [selectedContentTemplate]="
                globals.isLessThan1200Width ? templateRefNonDisclosure : null
              "
              (click)="
                selectedFinancialSituationOptionClick(
                  $event,
                  'non-disclosure',
                  'financial-situation-group'
                )
              "
            ></app-radio>
          </div>
        </div>

        <ng-template #templateRefFinancialStatement>
          <div
            *ngIf="
              selectedFinancialSituationOptionControl.value ===
              'financial-statement'
            "
            class="inner-container"
          >
            <div class="title">Latest financial statement</div>
            <div
              class="description"
              *ngIf="!financialStatementFilesFormArray.length"
            >
              Please upload a copy of your organisation’s latest audited or
              certified financial statement
            </div>
            <app-file-upload
              [class.fs-file-upload-wrapper]="
                financialStatementFilesFormArray.length
              "
              [maxNoOfUpload]="1"
              [form]="financialStatementFilesFormGroup"
              (handleFileUpload)="clearFinancialStatementDate()"
              (handleError)="showFileUploadErrorModal($event)"
            ></app-file-upload>
            <div
              *ngIf="
                financialStatementFilesFormArray.errors?.required &&
                financialStatementFilesFormArray?.touched
              "
              class="error fna-mt-15"
            >
              Please upload your organisation's financial statement
            </div>
            <div
              class="fna-mt-30"
              *ngIf="financialStatementFilesFormArray.length"
            >
              <app-date-picker
                label="Date of financial statement"
                formControlName="financialStatementDate"
              ></app-date-picker>
              <!-- Showing error method -->
              <div
                *ngIf="
                  financialStatementDateControl.errors?.required &&
                  !financialStatementDateControl.errors?.invalid &&
                  financialStatementDateControl?.touched
                "
                class="error fna-mt-5"
              >
                Please enter the date of financial statement
              </div>
              <div
                *ngIf="
                  financialStatementDateControl.errors?.invalid &&
                  financialStatementDateControl?.touched
                "
                class="error fna-mt-5"
              >
                Please enter a valid date
              </div>
              <div class="file-upload-description">
                Note: Whilst the above information does not prohibit you from
                making an investment, if your Net Current Assets and Net Assets
                are less than the amount be invested, this may mean that the
                investment exceeds the value of your organisation. You should
                ensure that this investment is appropriate for your organisation
                and that you will still have the financial ability to fulfil
                payment of your contractual liabilities as they arise. You
                should always ensure that this is the case for any investment
                that you make. <br />
                <br />
                <b>Net Current Assets</b>: All current assets minus all current
                liabilities due <br />
                <b>Net Assets</b>: Current assets – Current liabilities +
                Non-current assets – Long term liabilities
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #templateRefOtherDocuments>
          <div
            *ngIf="
              selectedFinancialSituationOptionControl.value ===
              'other-documents'
            "
            class="inner-container"
          >
            <div class="title">Other relevant documents</div>
            <div class="description">You may upload more than one document</div>
            <app-file-upload
              [maxNoOfUpload]="3"
              [showDocumentType]="false"
              [form]="otherFinancialSituationFilesFormGroup"
              (handleError)="showFileUploadErrorModal($event)"
            ></app-file-upload>
            <div
              *ngIf="
                otherFinancialSituationFilesFormArray.errors?.required &&
                otherFinancialSituationFilesFormArray?.touched
              "
              class="error fna-mt-15"
            >
              Please upload the relevant documents
            </div>
          </div>
        </ng-template>
        <ng-template #templateRefNonDisclosure>
          <div
            *ngIf="
              selectedFinancialSituationOptionControl.value === 'non-disclosure'
            "
            class="inner-container"
          >
            <div>
              <app-checkbox
                label="We do not wish to disclose any financial information and have an amount of"
                formControlName="isFinancialSituationNonDisclosureConfirm"
                [border]="false"
              >
                <div description>
                  <!-- Showing error method -->
                  <div
                    *ngIf="
                      isFinancialSituationNonDisclosureConfirmControl.touched &&
                      isFinancialSituationNonDisclosureConfirmControl.errors
                        ?.required
                    "
                    class="error"
                  >
                    Please acknowledge the non-disclosure
                  </div>

                  <div class="field-wrapper">
                    <label>
                      <span class="amount-label">Amount</span>
                      <span class="fs-amount-wrapper">
                        <span class="fs-amount-field">
                          <app-dropdown
                            [disabled]="
                              !isFinancialSituationNonDisclosureConfirmControl.value
                            "
                            [options]="fsCurrencyList"
                            [value]="
                              nonDisclosureFinancialSituationCapitalCurrencyControl.value
                            "
                            formControlName="nonDisclosureFinancialSituationCapitalCurrency"
                            class="fs-currency-list"
                            [hasError]="
                              (!nonDisclosureFinancialSituationCapitalAmountControl?.valid &&
                                nonDisclosureFinancialSituationCapitalAmountControl?.touched) ||
                              false
                            "
                          ></app-dropdown>
                          <input
                            appDisableMouseWheel
                            type="number"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            min="0"
                            [attr.disabled]="
                              isFinancialSituationNonDisclosureConfirmControl.value
                                ? null
                                : true
                            "
                            [class.submit-error]="
                              !nonDisclosureFinancialSituationCapitalAmountControl?.valid &&
                              nonDisclosureFinancialSituationCapitalAmountControl?.touched
                            "
                            formControlName="nonDisclosureFinancialSituationCapitalAmount"
                          />
                        </span>
                        <span class="fs-amount-label"
                          >for investment purposes.</span
                        >
                      </span>
                      <!-- Showing error method -->
                      <span
                        *ngIf="
                          nonDisclosureFinancialSituationCapitalAmountControl.touched &&
                          nonDisclosureFinancialSituationCapitalAmountControl
                            .errors?.required
                        "
                        class="error"
                      >
                        Please enter amount
                      </span>
                    </label>
                  </div>
                </div>
              </app-checkbox>
              <div class="fs-description">
                Accordingly, we accept that we will receive no advice or
                recommendation from OCBC Bank on the amount to be invested. It
                is our responsibility to ensure that the products are suitable
                in the light of our financial position and investment objectives
                and we confirm that we are fully responsible for our investment
                decision which we have made in our sole judgement and
                discretion.<br /><br />
                For the avoidance of doubt, the said amount for investment
                purposes relates to the amount of US$ or S$ available for the
                initial transaction between your organisation and OCBC Bank. For
                each subsequent transaction, OCBC Bank will confirm with you on
                the then amount available for investment purposes.
              </div>
            </div>
          </div>
        </ng-template>

        <ng-container *ngIf="!globals.isLessThan1200Width">
          <ng-container
            *ngTemplateOutlet="templateRefFinancialStatement"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="templateRefOtherDocuments"
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="templateRefNonDisclosure"
          ></ng-container>
        </ng-container>
      </section>

      <section class="box investment-history-group">
        <app-label-field>
          <ng-container title>Investment history</ng-container>
          <ng-container helperText>Please choose one option</ng-container>
        </app-label-field>

        <div class="row radio-row">
          <div class="col-xl-4">
            <app-radio
              name="isInvestmentHistoryDisclosed"
              formControlName="isInvestmentHistoryDisclosed"
              [radioValue]="true"
              label="Current investment history"
              [value]="isInvestmentHistoryDisclosedControl.value"
              [selectedContentTemplate]="
                globals.isLessThan1200Width
                  ? templateRefMobileInvestmentHistoryFields
                  : null
              "
              (click)="
                selectedInvestmentHistoryClick(
                  $event,
                  true,
                  'investment-history-group'
                )
              "
            ></app-radio>
          </div>
          <div class="col-xl-4">
            <app-radio
              name="isInvestmentHistoryDisclosed"
              formControlName="isInvestmentHistoryDisclosed"
              [radioValue]="false"
              label="Non-disclosure"
              [value]="isInvestmentHistoryDisclosedControl.value"
              (click)="
                selectedInvestmentHistoryClick(
                  $event,
                  false,
                  'investment-history-group'
                )
              "
              [selectedContentTemplate]="
                globals.isLessThan1200Width
                  ? templateRefMobileInvestmentHistoryNonDisclosureFields
                  : null
              "
            ></app-radio>
          </div>
        </div>
        <ng-template #templateRefMobileInvestmentHistoryFields>
          <div
            *ngFor="
              let investmentControl of currentInvestmentHistoryFormArray.controls;
              index as investmentIndex
            "
            formArrayName="currentInvestmentHistory"
          >
            <ng-container [formGroupName]="investmentIndex">
              <div class="inner-container fna-mb-20">
                <div class="field-wrapper fna-mb-30">
                  <label>
                    <span>Investment</span>
                    <input
                      [class.submit-error]="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.touched
                      "
                      [value]="investmentControl.get('name')?.value"
                      formControlName="name"
                    />
                    <span
                      *ngIf="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.errors?.required &&
                        investmentControl.get('name')?.touched
                      "
                      class="error"
                    >
                      Please enter the name of investment
                    </span>
                    <span
                      *ngIf="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.errors?.pattern &&
                        investmentControl.get('name')?.touched
                      "
                      class="error"
                    >
                      The following characters are not allowed:
                      {{ INVALID_CHARACTERS }}
                    </span>
                    <span
                      *ngIf="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.errors?.maxlength &&
                        investmentControl.get('name')?.touched
                      "
                      class="error"
                    >
                      You have exceeded the maximum
                      {{ MAX_CHARACTERS }} characters limit
                    </span>
                  </label>
                </div>
                <div class="fna-mb-30">
                  <app-date-picker
                    label="Date of Purchase"
                    formControlName="dateOfPurchase"
                  ></app-date-picker>
                  <div
                    *ngIf="
                      investmentControl.get('dateOfPurchase')?.errors
                        ?.required &&
                      !investmentControl.get('dateOfPurchase')?.errors
                        ?.invalid &&
                      investmentControl.get('dateOfPurchase')?.touched
                    "
                    class="error fna-mt-5"
                  >
                    Please enter a valid date
                  </div>
                  <div
                    *ngIf="
                      investmentControl.get('dateOfPurchase')?.errors
                        ?.invalid &&
                      investmentControl.get('dateOfPurchase')?.touched
                    "
                    class="error fna-mt-5"
                  >
                    Please enter a valid date
                  </div>
                </div>
                <div class="field-wrapper fna-mb-30">
                  <label>
                    <span>Amount Invested</span>
                    <span class="investment-amount-field">
                      <app-dropdown
                        [options]="investmentCurrencyList"
                        [value]="investmentControl.get('currency')?.value"
                        formControlName="currency"
                        class="investment-currency-list"
                        [hasError]="
                          (!investmentControl.get('amountInvested')?.valid &&
                            investmentControl.get('amountInvested')?.touched) ||
                          false
                        "
                      ></app-dropdown>
                      <input
                        appDisableMouseWheel
                        type="number"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        min="0"
                        [class.submit-error]="
                          !investmentControl.get('amountInvested')?.valid &&
                          investmentControl.get('amountInvested')?.touched
                        "
                        [value]="investmentControl.get('amountInvested')?.value"
                        formControlName="amountInvested"
                      />
                    </span>
                    <span
                      class="error"
                      *ngIf="
                        !investmentControl.get('amountInvested')?.valid &&
                        investmentControl.get('amountInvested')?.touched
                      "
                      >Please enter the amount invested</span
                    >
                  </label>
                </div>
                <div class="field-wrapper">
                  <label>
                    <span>Tenor</span>
                    <span class="investment-tenor-field">
                      <input
                        appDisableMouseWheel
                        type="number"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        min="0"
                        [class.submit-error]="
                          !investmentControl.get('tenorValue')?.valid &&
                          investmentControl.get('tenorValue')?.touched
                        "
                        [value]="investmentControl.get('tenorValue')?.value"
                        formControlName="tenorValue"
                        (input)="
                          characterLimit(
                            $event,
                            2,
                            investmentControl.get('tenorValue')
                          )
                        "
                      />
                      <app-dropdown
                        [options]="tenorUnitList"
                        [value]="investmentControl.get('tenorUnit')?.value"
                        formControlName="tenorUnit"
                        class="tenor-unit-list"
                        [hasError]="
                          (!investmentControl.get('tenorValue')?.valid &&
                            investmentControl.get('tenorValue')?.touched) ||
                          false
                        "
                        [fullWidth]="true"
                      ></app-dropdown>
                    </span>
                    <span
                      class="error"
                      *ngIf="
                        !investmentControl.get('tenorValue')?.valid &&
                        investmentControl.get('tenorValue')?.touched
                      "
                      >Please enter the tenor period</span
                    >
                  </label>
                </div>
                <div
                  class="delete-mobile blue-link"
                  [class.hidden]="
                    investmentIndex === 0 &&
                    currentInvestmentHistoryFormArray.length === 1
                  "
                  (click)="removeHistoryInvestmentButtonClick(investmentIndex)"
                >
                  <img src="assets/icons/ic-delete-blue@3x.svg" alt="remove" />
                  Remove
                </div>
              </div>
            </ng-container>
          </div>
          <div (click)="addHistoryInvestmentButtonClick()">
            <img src="assets/icons/ic-add@3x.svg" alt="add more" />
            <span class="blue-link">Add more</span>
          </div>
        </ng-template>
        <ng-template #templateRefMobileInvestmentHistoryNonDisclosureFields>
          <div *ngIf="isInvestmentHistoryDisclosedControl.value === false">
            <div class="inner-container">
              <app-checkbox
                label="We do not wish to disclose our investment history. By not providing this information, we recognise that OCBC Bank will not have all relevant information and this will reduce and affect the quality of any advice or recommendation(s) we receive."
                formControlName="isInvestmentHistoryNonDisclosureConfirm"
                [border]="false"
              >
              </app-checkbox>
              <!-- Showing error method -->
              <div
                *ngIf="
                  isInvestmentHistoryNonDisclosureConfirmControl.touched &&
                  isInvestmentHistoryNonDisclosureConfirmControl.errors
                    ?.required
                "
                class="error"
              >
                Please acknowledge the non-disclosure
              </div>
            </div>
          </div>
        </ng-template>

        <ng-container *ngIf="!globals.isLessThan1200Width">
          <div
            *ngIf="isInvestmentHistoryDisclosedControl.value === true"
            class="investment-table-wrapper"
          >
            <table class="table investment-table">
              <thead>
                <tr>
                  <th scope="col">Investment</th>
                  <th scope="col">Date of Purchase</th>
                  <th scope="col">Amount Invested</th>
                  <th scope="col">Tenor</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let investmentControl of currentInvestmentHistoryFormArray.controls;
                    index as investmentIndex
                  "
                  formArrayName="currentInvestmentHistory"
                  class="investment-row"
                >
                  <ng-container [formGroupName]="investmentIndex">
                    <td>
                      <div class="field-wrapper">
                        <label>
                          <input
                            [class.submit-error]="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.touched
                            "
                            [value]="investmentControl.get('name')?.value"
                            formControlName="name"
                          />
                          <span
                            *ngIf="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.errors?.required &&
                              investmentControl.get('name')?.touched
                            "
                            class="error"
                          >
                            Please enter the name of investment
                          </span>
                          <span
                            *ngIf="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.errors?.pattern &&
                              investmentControl.get('name')?.touched
                            "
                            class="error"
                          >
                            The following characters are not allowed:
                            {{ INVALID_CHARACTERS }}
                          </span>
                          <span
                            *ngIf="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.errors
                                ?.maxlength &&
                              investmentControl.get('name')?.touched
                            "
                            class="error"
                          >
                            You have exceeded the maximum
                            {{ MAX_CHARACTERS }} characters limit
                          </span>
                        </label>
                      </div>
                    </td>
                    <td>
                      <app-date-picker
                        formControlName="dateOfPurchase"
                        class="investment-date-field"
                      ></app-date-picker>
                      <div
                        *ngIf="
                          investmentControl.get('dateOfPurchase')?.errors
                            ?.required &&
                          !investmentControl.get('dateOfPurchase')?.errors
                            ?.invalid &&
                          investmentControl.get('dateOfPurchase')?.touched
                        "
                        class="error fna-mt-5"
                      >
                        Please enter a valid date
                      </div>
                      <div
                        *ngIf="
                          investmentControl.get('dateOfPurchase')?.errors
                            ?.invalid &&
                          investmentControl.get('dateOfPurchase')?.touched
                        "
                        class="error fna-mt-5"
                      >
                        Please enter a valid date
                      </div>
                    </td>
                    <td>
                      <div class="field-wrapper">
                        <label>
                          <span class="investment-amount-field">
                            <app-dropdown
                              [options]="investmentCurrencyList"
                              [value]="investmentControl.get('currency')?.value"
                              formControlName="currency"
                              class="investment-currency-list"
                              [hasError]="
                                (!investmentControl.get('amountInvested')
                                  ?.valid &&
                                  investmentControl.get('amountInvested')
                                    ?.touched) ||
                                false
                              "
                            ></app-dropdown>
                            <input
                              appDisableMouseWheel
                              type="number"
                              pattern="[0-9]*"
                              inputmode="numeric"
                              min="0"
                              [class.submit-error]="
                                !investmentControl.get('amountInvested')
                                  ?.valid &&
                                investmentControl.get('amountInvested')?.touched
                              "
                              [value]="
                                investmentControl.get('amountInvested')?.value
                              "
                              formControlName="amountInvested"
                            />
                          </span>
                          <span
                            class="error"
                            *ngIf="
                              !investmentControl.get('amountInvested')?.valid &&
                              investmentControl.get('amountInvested')?.touched
                            "
                            >Please enter the amount invested</span
                          >
                        </label>
                      </div>
                    </td>
                    <td>
                      <div class="field-wrapper">
                        <label>
                          <span class="investment-tenor-field">
                            <input
                              appDisableMouseWheel
                              type="number"
                              pattern="[0-9]*"
                              inputmode="numeric"
                              min="0"
                              [class.submit-error]="
                                !investmentControl.get('tenorValue')?.valid &&
                                investmentControl.get('tenorValue')?.touched
                              "
                              [value]="
                                investmentControl.get('tenorValue')?.value
                              "
                              formControlName="tenorValue"
                              (input)="
                                characterLimit(
                                  $event,
                                  2,
                                  investmentControl.get('tenorValue')
                                )
                              " />
                            <app-dropdown
                              [options]="tenorUnitList"
                              [value]="
                                investmentControl.get('tenorUnit')?.value
                              "
                              formControlName="tenorUnit"
                              class="tenor-unit-list"
                              [hasError]="
                                (!investmentControl.get('tenorValue')?.valid &&
                                  investmentControl.get('tenorValue')
                                    ?.touched) ||
                                false
                              "
                            ></app-dropdown
                          ></span>
                          <span
                            class="error"
                            *ngIf="
                              !investmentControl.get('tenorValue')?.valid &&
                              investmentControl.get('tenorValue')?.touched
                            "
                            >Please enter the tenor period</span
                          >
                        </label>
                      </div>
                    </td>
                    <td class="delete">
                      <img
                        src="assets/icons/ic-delete@3x.svg"
                        alt="remove"
                        [class.invisible]="
                          investmentIndex === 0 &&
                          currentInvestmentHistoryFormArray.length === 1
                        "
                        (click)="
                          removeHistoryInvestmentButtonClick(investmentIndex)
                        "
                      />
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
            <div
              class="add-more blue-link"
              (click)="addHistoryInvestmentButtonClick()"
            >
              <img src="assets/icons/ic-add@3x.svg" alt="add more" />
              Add more
            </div>
          </div>
          <ng-container
            *ngTemplateOutlet="
              templateRefMobileInvestmentHistoryNonDisclosureFields
            "
          ></ng-container>
        </ng-container>
      </section>

      <section class="box investment-portfolio-group">
        <app-label-field>
          <ng-container title>Investment portfolio</ng-container>
          <ng-container helperText>Please choose one option</ng-container>
        </app-label-field>
        <div class="row radio-row">
          <div class="col-xl-4">
            <app-radio
              name="isInvestmentPortfolioDisclosed"
              formControlName="isInvestmentPortfolioDisclosed"
              [radioValue]="true"
              label="Current investment portfolio"
              [value]="isInvestmentPortfolioDisclosedControl.value"
              [selectedContentTemplate]="
                globals.isLessThan1200Width
                  ? templateRefMobileInvestmentPortfolioFields
                  : null
              "
              (click)="
                selectedInvestmentPortfolioClick(
                  $event,
                  true,
                  'investment-portfolio-group'
                )
              "
            ></app-radio>
          </div>
          <div class="col-xl-4">
            <app-radio
              name="isInvestmentPortfolioDisclosed"
              formControlName="isInvestmentPortfolioDisclosed"
              [radioValue]="false"
              label="Non-disclosure"
              [value]="isInvestmentPortfolioDisclosedControl.value"
              (click)="
                selectedInvestmentPortfolioClick(
                  $event,
                  false,
                  'investment-portfolio-group'
                )
              "
              [selectedContentTemplate]="
                globals.isLessThan1200Width
                  ? templateRefMobileInvestmentPortfolioNonDisclosureFields
                  : null
              "
            ></app-radio>
          </div>
        </div>
        <ng-template #templateRefMobileInvestmentPortfolioFields>
          <div
            *ngFor="
              let investmentControl of currentInvestmentPortfolioFormArray.controls;
              index as investmentIndex
            "
            formArrayName="currentInvestmentPortfolio"
          >
            <ng-container [formGroupName]="investmentIndex">
              <div class="inner-container fna-mb-20">
                <div class="field-wrapper fna-mb-30">
                  <label>
                    <span>Investment</span>
                    <input
                      [class.submit-error]="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.touched
                      "
                      [value]="investmentControl.get('name')?.value"
                      formControlName="name"
                    />
                    <span
                      *ngIf="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.errors?.required &&
                        investmentControl.get('name')?.touched
                      "
                      class="error"
                    >
                      Please enter the name of investment
                    </span>
                    <span
                      *ngIf="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.errors?.pattern &&
                        investmentControl.get('name')?.touched
                      "
                      class="error"
                    >
                      The following characters are not allowed:
                      {{ INVALID_CHARACTERS }}
                    </span>
                    <span
                      *ngIf="
                        !investmentControl.get('name')?.valid &&
                        investmentControl.get('name')?.errors?.maxlength &&
                        investmentControl.get('name')?.touched
                      "
                      class="error"
                    >
                      You have exceeded the maximum
                      {{ MAX_CHARACTERS }} characters limit
                    </span>
                  </label>
                </div>
                <div class="fna-mb-30">
                  <app-date-picker
                    label="Date of Purchase"
                    formControlName="dateOfPurchase"
                  ></app-date-picker>
                  <div
                    *ngIf="
                      investmentControl.get('dateOfPurchase')?.errors
                        ?.required &&
                      !investmentControl.get('dateOfPurchase')?.errors
                        ?.invalid &&
                      investmentControl.get('dateOfPurchase')?.touched
                    "
                    class="error fna-mt-5"
                  >
                    Please enter a valid date
                  </div>
                  <div
                    *ngIf="
                      investmentControl.get('dateOfPurchase')?.errors
                        ?.invalid &&
                      investmentControl.get('dateOfPurchase')?.touched
                    "
                    class="error fna-mt-5"
                  >
                    Please enter a valid date
                  </div>
                </div>
                <div class="field-wrapper fna-mb-30">
                  <label>
                    <span>Amount Invested</span>
                    <span class="investment-amount-field">
                      <app-dropdown
                        [options]="investmentCurrencyList"
                        [value]="investmentControl.get('currency')?.value"
                        formControlName="currency"
                        class="investment-currency-list"
                        [hasError]="
                          (!investmentControl.get('amountInvested')?.valid &&
                            investmentControl.get('amountInvested')?.touched) ||
                          false
                        "
                      ></app-dropdown>
                      <input
                        appDisableMouseWheel
                        type="number"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        min="0"
                        [class.submit-error]="
                          !investmentControl.get('amountInvested')?.valid &&
                          investmentControl.get('amountInvested')?.touched
                        "
                        [value]="investmentControl.get('amountInvested')?.value"
                        formControlName="amountInvested"
                      />
                    </span>
                    <span
                      class="error"
                      *ngIf="
                        !investmentControl.get('amountInvested')?.valid &&
                        investmentControl.get('amountInvested')?.touched
                      "
                      >Please enter the amount invested</span
                    >
                  </label>
                </div>
                <div class="field-wrapper">
                  <label>
                    <span>Tenor</span>
                    <span class="investment-tenor-field">
                      <input
                        appDisableMouseWheel
                        type="number"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        min="0"
                        [class.submit-error]="
                          !investmentControl.get('tenorValue')?.valid &&
                          investmentControl.get('tenorValue')?.touched
                        "
                        [value]="investmentControl.get('tenorValue')?.value"
                        formControlName="tenorValue"
                        (input)="
                          characterLimit(
                            $event,
                            2,
                            investmentControl.get('tenorValue')
                          )
                        "
                      />
                      <app-dropdown
                        [options]="tenorUnitList"
                        [value]="investmentControl.get('tenorUnit')?.value"
                        formControlName="tenorUnit"
                        class="tenor-unit-list"
                        [hasError]="
                          (!investmentControl.get('tenorValue')?.valid &&
                            investmentControl.get('tenorValue')?.touched) ||
                          false
                        "
                        [fullWidth]="true"
                      ></app-dropdown>
                    </span>
                    <span
                      class="error"
                      *ngIf="
                        !investmentControl.get('tenorValue')?.valid &&
                        investmentControl.get('tenorValue')?.touched
                      "
                      >Please enter the tenor period</span
                    >
                  </label>
                </div>
                <div
                  class="delete-mobile blue-link"
                  [class.hidden]="
                    investmentIndex === 0 &&
                    currentInvestmentPortfolioFormArray.length === 1
                  "
                  (click)="
                    removePortfolioInvestmentButtonClick(investmentIndex)
                  "
                >
                  <img src="assets/icons/ic-delete-blue@3x.svg" alt="remove" />
                  Remove
                </div>
              </div>
            </ng-container>
          </div>
          <div (click)="addPortfolioInvestmentButtonClick()">
            <img src="assets/icons/ic-add@3x.svg" alt="add more" />
            <span class="blue-link">Add more</span>
          </div>
        </ng-template>
        <ng-template #templateRefMobileInvestmentPortfolioNonDisclosureFields>
          <div *ngIf="isInvestmentPortfolioDisclosedControl.value === false">
            <div class="inner-container">
              <app-checkbox
                label="We do not wish to disclose our investment history. By not providing this information, we recognise that OCBC Bank will not have all relevant information and this will reduce and affect the quality of any advice or recommendation(s) we receive."
                formControlName="isInvestmentPortfolioNonDisclosureConfirm"
                [border]="false"
              >
              </app-checkbox>
              <!-- Showing error method -->
              <div
                *ngIf="
                  isInvestmentPortfolioNonDisclosureConfirmControl.touched &&
                  isInvestmentPortfolioNonDisclosureConfirmControl.errors
                    ?.required
                "
                class="error"
              >
                Please acknowledge the non-disclosure
              </div>
            </div>
          </div>
        </ng-template>

        <ng-container *ngIf="!globals.isLessThan1200Width">
          <div *ngIf="isInvestmentPortfolioDisclosedControl.value === true">
            <table class="table investment-table">
              <thead>
                <tr>
                  <th scope="col">Investment</th>
                  <th scope="col">Date of Purchase</th>
                  <th scope="col">Amount Invested</th>
                  <th scope="col">Tenor</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let investmentControl of currentInvestmentPortfolioFormArray.controls;
                    index as investmentIndex
                  "
                  formArrayName="currentInvestmentPortfolio"
                  class="investment-row"
                >
                  <ng-container [formGroupName]="investmentIndex">
                    <td>
                      <div class="field-wrapper">
                        <label>
                          <input
                            [class.submit-error]="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.touched
                            "
                            [value]="investmentControl.get('name')?.value"
                            formControlName="name"
                          />
                          <span
                            *ngIf="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.errors?.required &&
                              investmentControl.get('name')?.touched
                            "
                            class="error"
                          >
                            Please enter the name of investment
                          </span>
                          <span
                            *ngIf="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.errors?.pattern &&
                              investmentControl.get('name')?.touched
                            "
                            class="error"
                          >
                            The following characters are not allowed:
                            {{ INVALID_CHARACTERS }}
                          </span>
                          <span
                            *ngIf="
                              !investmentControl.get('name')?.valid &&
                              investmentControl.get('name')?.errors
                                ?.maxlength &&
                              investmentControl.get('name')?.touched
                            "
                            class="error"
                          >
                            You have exceeded the maximum
                            {{ MAX_CHARACTERS }} characters limit
                          </span>
                        </label>
                      </div>
                    </td>
                    <td>
                      <app-date-picker
                        formControlName="dateOfPurchase"
                        class="investment-date-field"
                      ></app-date-picker>
                      <div
                        *ngIf="
                          investmentControl.get('dateOfPurchase')?.errors
                            ?.required &&
                          !investmentControl.get('dateOfPurchase')?.errors
                            ?.invalid &&
                          investmentControl.get('dateOfPurchase')?.touched
                        "
                        class="error fna-mt-5"
                      >
                        Please enter a valid date
                      </div>
                      <div
                        *ngIf="
                          investmentControl.get('dateOfPurchase')?.errors
                            ?.invalid &&
                          investmentControl.get('dateOfPurchase')?.touched
                        "
                        class="error fna-mt-5"
                      >
                        Please enter a valid date
                      </div>
                    </td>
                    <td>
                      <div class="field-wrapper">
                        <label>
                          <span class="investment-amount-field">
                            <app-dropdown
                              [options]="investmentCurrencyList"
                              [value]="investmentControl.get('currency')?.value"
                              formControlName="currency"
                              class="investment-currency-list"
                              [hasError]="
                                (!investmentControl.get('amountInvested')
                                  ?.valid &&
                                  investmentControl.get('amountInvested')
                                    ?.touched) ||
                                false
                              "
                            ></app-dropdown>
                            <input
                              appDisableMouseWheel
                              type="number"
                              pattern="[0-9]*"
                              inputmode="numeric"
                              min="0"
                              [class.submit-error]="
                                !investmentControl.get('amountInvested')
                                  ?.valid &&
                                investmentControl.get('amountInvested')?.touched
                              "
                              [value]="
                                investmentControl.get('amountInvested')?.value
                              "
                              formControlName="amountInvested"
                            />
                          </span>
                          <span
                            class="error"
                            *ngIf="
                              !investmentControl.get('amountInvested')?.valid &&
                              investmentControl.get('amountInvested')?.touched
                            "
                            >Please enter the amount invested</span
                          >
                        </label>
                      </div>
                    </td>
                    <td>
                      <div class="field-wrapper">
                        <label>
                          <span class="investment-tenor-field">
                            <input
                              appDisableMouseWheel
                              type="number"
                              pattern="[0-9]*"
                              inputmode="numeric"
                              min="0"
                              [class.submit-error]="
                                !investmentControl.get('tenorValue')?.valid &&
                                investmentControl.get('tenorValue')?.touched
                              "
                              [value]="
                                investmentControl.get('tenorValue')?.value
                              "
                              formControlName="tenorValue"
                              (input)="
                                characterLimit(
                                  $event,
                                  2,
                                  investmentControl.get('tenorValue')
                                )
                              " />
                            <app-dropdown
                              [options]="tenorUnitList"
                              [value]="
                                investmentControl.get('tenorUnit')?.value
                              "
                              formControlName="tenorUnit"
                              class="tenor-unit-list"
                              [hasError]="
                                (!investmentControl.get('tenorValue')?.valid &&
                                  investmentControl.get('tenorValue')
                                    ?.touched) ||
                                false
                              "
                            ></app-dropdown
                          ></span>
                          <span
                            class="error"
                            *ngIf="
                              !investmentControl.get('tenorValue')?.valid &&
                              investmentControl.get('tenorValue')?.touched
                            "
                            >Please enter the tenor period</span
                          >
                        </label>
                      </div>
                    </td>
                    <td class="delete">
                      <img
                        src="assets/icons/ic-delete@3x.svg"
                        alt="remove"
                        [class.invisible]="
                          investmentIndex === 0 &&
                          currentInvestmentPortfolioFormArray.length === 1
                        "
                        (click)="
                          removePortfolioInvestmentButtonClick(investmentIndex)
                        "
                      />
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
            <div
              class="add-more blue-link"
              (click)="addPortfolioInvestmentButtonClick()"
            >
              <img src="assets/icons/ic-add@3x.svg" alt="add more" />
              Add more
            </div>
          </div>
          <ng-container
            *ngTemplateOutlet="
              templateRefMobileInvestmentPortfolioNonDisclosureFields
            "
          ></ng-container>
        </ng-container>
      </section>

      <section class="box">
        <app-label-field>
          <ng-container title>Risk profile</ng-container>
          <ng-container description>
            Please indicate what you believe is your organisation’s risk
            profile, based on your experience and requirements
            <!-- Showing error method -->
            <div
              *ngIf="
                model.shouldShowErrors &&
                indicatedRiskProfileControl.errors?.required
              "
              class="error fna-mt-10"
            >
              Please select an option
            </div>
          </ng-container>
        </app-label-field>

        <app-radio
          formControlName="indicatedRiskProfile"
          name="indicatedRiskProfile"
          radioValue="conservative"
          [value]="indicatedRiskProfileControl.value"
          label="Conservative"
          description="Your organisation does not wish to take any significant investment
        risk. Your organisation’s priority is the safeguarding of your
        investment capital and your organisation is prepared to sacrifice
        higher returns to achieve "
        ></app-radio>
        <app-radio
          formControlName="indicatedRiskProfile"
          name="indicatedRiskProfile"
          radioValue="moderate"
          [value]="indicatedRiskProfileControl.value"
          label="Moderate"
          description="Your organisation is prepared to take some risk in the value of your
        organisation’s investment capital, in order to generate investment
        returns."
        ></app-radio>
        <app-radio
          formControlName="indicatedRiskProfile"
          name="indicatedRiskProfile"
          radioValue="aggressive"
          [value]="indicatedRiskProfileControl.value"
          label="Aggressive"
          description="Your organisation is prepared to take the risk of significant loss,
        including total loss or more, of your organisation’s investment
        capital in order to generate higher investment returns."
        ></app-radio>
      </section>

      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>
        <app-next-button buttonType="submit"></app-next-button>
      </div>
    </form>

    <div *ngIf="globals.isDebug" class="mt56">
      <h3>Information for developers, please ignore</h3>
      <h4>Data</h4>
      <pre class="debug-log-mono">{{ model.data | json }}</pre>
      <h5>Form value</h5>
      <pre class="debug-log-mono">{{ form.value | json }}</pre>
    </div>
  </div>
</app-screen-content>

<ng-template> </ng-template>
